import { Platform, ViewStyle } from 'react-native';

/**
 * Creates shadow styles that work across platforms
 * On web: uses boxShadow
 * On native: uses shadow* props
 */
export function createShadow(
  offsetX: number,
  offsetY: number,
  opacity: number,
  radius: number,
  elevation?: number
): ViewStyle {
  if (Platform.OS === 'web') {
    // Convert to CSS boxShadow for web
    const alpha = Math.round(opacity * 255).toString(16).padStart(2, '0');
    return {
      boxShadow: `${offsetX}px ${offsetY}px ${radius}px rgba(0, 0, 0, ${opacity})`,
    } as ViewStyle;
  } else {
    // Use React Native shadow props for iOS/Android
    return {
      shadowColor: '#000',
      shadowOffset: { width: offsetX, height: offsetY },
      shadowOpacity: opacity,
      shadowRadius: radius,
      elevation: elevation || Math.round(radius),
    };
  }
}

/**
 * Common shadow presets
 */
export const shadows = {
  sm: createShadow(0, 1, 0.05, 2, 1),
  md: createShadow(0, 2, 0.1, 4, 2),
  lg: createShadow(0, 4, 0.3, 8, 5),
  xl: createShadow(0, 8, 0.3, 16, 8),
  bottom: createShadow(0, -2, 0.1, 8, 5),
};

